import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {DocusignFailComponent} from "./docusign-fail/docusign-fail.component";
import {DocusignSuccessComponent} from "./docusign-success/docusign-success.component";

const routes: Routes = [
  { path: 'sign-fail', component: DocusignFailComponent},
  { path: 'sign-success', component: DocusignSuccessComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class DocusignRoutingModule {
  static components = [DocusignFailComponent, DocusignSuccessComponent]
}
